/**
 * sameRouteScroll — small helper for <Link> components so clicking a link
 * to the page you're ALREADY on smooth-scrolls back to the top instead of
 * silently no-op'ing (React Router's default behavior).
 *
 * Usage:
 *   const onClick = useSameRouteScroll('/en/guides/list');
 *   <Link to="/en/guides/list" onClick={onClick}>All Guides</Link>
 *
 * Trailing slashes and hash fragments are stripped before comparison so
 * `/foo` and `/foo/` match. The scroll uses smooth behavior to mirror the
 * existing header-logo pattern in Header.jsx.
 */
import { useLocation } from 'react-router-dom';
import { useCallback } from 'react';

const normalize = (p) => (p || '').split('#')[0].split('?')[0].replace(/\/+$/, '') || '/';

export function useSameRouteScroll(targetPath) {
  const location = useLocation();
  return useCallback(
    (e) => {
      if (normalize(location.pathname) === normalize(targetPath)) {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    [location.pathname, targetPath],
  );
}
